import React, { useState, useEffect, useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import Avatar from "@mui/material/Avatar";
import LogoutIcon from "@mui/icons-material/Logout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import HailIcon from "@mui/icons-material/Hail";
import SettingsIcon from "@mui/icons-material/Settings";
import EventIcon from "@mui/icons-material/Event";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import RefreshIcon from "@mui/icons-material/Refresh";
import ExpandIcon from "@mui/icons-material/Expand";
import LinearProgress from "@mui/material/LinearProgress";
import moment from "moment";
import packageJson from "../../../package.json";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { redux_resetLoginSettings } from "../../Redux/LoginSettings";
import { redux_logout } from "../../Redux/Account";
import HomeIcon from "@mui/icons-material/Home";
import { useTranslation } from "react-i18next";
import { useIdleTimer } from "react-idle-timer";
import { useLoaderData } from "react-router-dom";

function Topbar({
  collapse,
  setcollapse,
  page,
  refreshCalls,
  setrefreshCalls,
  loading,
  setLoading,
}) {
  // 1) Data
  const navigate = useNavigate();
  const server_settings = useLoaderData();
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const ApplicationSettings = useSelector(
    (state) => state.ApplicationSettings.value
  );
  const Account = useSelector((state) => state.Account.value);
  const Login = useSelector((state) => state.LoginSettings.value);
  const [stateIdle, setstateIdle] = useState("q ");
  const [count, setCount] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [state, setState] = useState({
    left: false,
  });

  // 2) useEffect
  useEffect(() => {
    //console.log("Login Settings LANG:", Login.Language);

    i18n.changeLanguage(Login.Language);

    if (Account.token == undefined || Account.token == "") {
      navigate("/");
    }
    return;
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  // 3) Function

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const LogoutFunciton = () => {
    dispatch(redux_logout());
    dispatch(redux_resetLoginSettings());
  };

  const onIdle = () => {
    setstateIdle("Idle");
    LogoutFunciton();
    navigate("/");
  };

  const onActive = () => {
    setstateIdle("Active");
  };

  const onAction = () => {
    setCount(count + 1);
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: 1800_000, // 30 mins
    throttle: 500,
  });

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
      //className="GlassDrawer flex-1  rounded-r-md"
      className="GlassDrawer flex-1  rounded-r-md flex flex-col justify-between"
    >
      <div className="mt-3 mb-1 p-1 text-center m-auto flex justify-center">
        <Avatar
          alt="Hotel Button"
          src={
            process.env.PUBLIC_URL + "/Images/" + Login.ServerName + "/Logo.png"
          }
          sx={{ width: 86, height: 86 }}
        />
      </div>

      <div className="text-center px-2">
        {t("Name")} {" : " + Account.fname + " " + Account.sname}
      </div>
      <div className="text-center px-2 ">
        {t("Address")} {" : " + Account.address}
      </div>
      <div className="text-center px-2">
        {t("Phone")}
        {" : " + Account.mobile}
      </div>

      <Divider />
      <List className="flex-1">
        {[
          "Dashboard",
          "History",
          "Active Calls",
          "Reservations",
          "Settings",
          "Helper",
        ].map((text, index) => (
          <Link to={"/" + text} key={index} style={{ textDecoration: "none" }}>
            <ListItem
              key={text}
              disablePadding
              className={
                text === page ? "Primary_Main_Background Primary_Dark_Text" : ""
              }
            >
              <ListItemButton>
                <ListItemIcon>
                  {index === 0 && <DashboardIcon />}
                  {index === 1 && <ManageSearchIcon />}
                  {index === 2 && <HailIcon />}
                  {index === 3 && <EventIcon />}
                  {index === 4 && <SettingsIcon />}
                  {index === 5 && <HelpCenterIcon />}
                </ListItemIcon>
                <Typography
                  mt={0.5}
                  variant="body"
                  // style={{ fontWeight: "300" }}
                >
                  {index === 0 && t("Dashboard")}
                  {index === 1 && t("Calls_History")}
                  {index === 2 && t("Active_Calls")}
                  {index === 3 && t("Reservations")}
                  {index === 4 && t("Settings")}
                  {index === 5 && t("Help")}
                </Typography>
              </ListItemButton>
            </ListItem>
          </Link>
        ))}
      </List>
      <Divider />

      <div className="mt-5  bottom-1 w-full px-1">
        <div className="text-center mb-3">
          <p className="font-thin">{moment().format("DD MMMM Y").toString()}</p>
          <Typography variant="body2">
            {t("Version")} {packageJson.version}
          </Typography>
          <p className=" text-xs text-red-700">
            {t("Disconnect")}: <span className=" font-bold">{remaining}</span>
            {t("sec")}
          </p>
        </div>
        <Divider />
        <List>
          <Link
            to={"/"}
            style={{ textDecoration: "none" }}
            onClick={() => {
              LogoutFunciton();
            }}
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText primary={t("Αποσύνδεση")} />
              </ListItemButton>
            </ListItem>
          </Link>
        </List>
      </div>
    </Box>
  );

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        {loading && <LinearProgress />}
        <AppBar position="static" className="NavigationBar">
          <Toolbar className="NavigationBar">
            {["left"].map((anchor) => (
              <React.Fragment key={anchor}>
                <IconButton
                  size="large"
                  edge="start"
                  aria-label="menu"
                  sx={{ mr: 2 }}
                  onClick={toggleDrawer(anchor, true)}
                >
                  <MenuIcon />
                </IconButton>
                <Drawer
                  PaperProps={{
                    sx: {
                      backgroundColor: "transparent",
                    },
                  }}
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                >
                  {list(anchor)}
                </Drawer>
              </React.Fragment>
            ))}

            <div className="flex-1">
              <img
                className=" w-28 md:w-48 lg:w-56 "
                alt="Logo"
                src={
                  process.env.PUBLIC_URL +
                  "/Images/" +
                  Login.ServerName +
                  "/logo.gif"
                }
                //sx={{ width: 86, height: 86 }}
              />
            </div>

            {/* TopBar Right Buttons */}
            {page === "Dashboard" && (
              <>
                <div className="mr-3">
                  <IconButton
                    onClick={() => {
                      setLoading(true);
                      setrefreshCalls(!refreshCalls);
                    }}
                    className="shadow-sm Primary_Light_Background Primary_Dark_Text "
                  >
                    <RefreshIcon />
                  </IconButton>
                </div>
                <div className="">
                  <IconButton
                    className="shadow-sm  Primary_Light_Background Primary_Dark_Text"
                    onClick={() => {
                      setcollapse(!collapse);
                    }}
                  >
                    {collapse ? (
                      <>
                        <ExpandIcon />
                      </>
                    ) : (
                      <>
                        <CloseFullscreenIcon />
                      </>
                    )}
                  </IconButton>
                </div>
              </>
            )}
            {page !== "Dashboard" && (
              <>
                <div className="mr-3">
                  <IconButton
                    onClick={() => {
                      navigate("/Dashboard");
                    }}
                    className="shadow-sm Primary_Light_Background Primary_Dark_Text "
                  >
                    <HomeIcon />
                  </IconButton>
                </div>
              </>
            )}
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
}

export default Topbar;
